




































































































































import { Action } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";
import ChipsInput from "@/components/ChipsInput.vue";
import { Maintenancejob,EmailLog,SelectOption,EmailAttachment} from "@/models";
import TiptapEditor from "@/components/editor/TipTapEditor.vue";

@Component({ components: { ChipsInput,TiptapEditor } })
export default class extends Vue {
  public maintenancejob: Maintenancejob = new Maintenancejob();
  public email: EmailLog = new EmailLog();
  public toinvalid: boolean = false;
  public ccinvalid: boolean = false;
  public bccinvalid: boolean = false;
  public templateOptions: SelectOption[] = [];
  public templateOption: SelectOption = new SelectOption();
  public attachments: EmailAttachment[] = [];
  @Action("maintenancejobs/sendEmail")
  public sendEmail: (email: EmailLog) => Promise<void>;

  public async init(maintenancejob: Maintenancejob) {
    // Reset previous entries
    this.maintenancejob = maintenancejob;
    this.email = new EmailLog();
    this.email.maintenancejobid = maintenancejob.id;
    this.fromaddress = "software@onecentralmaintenance.com";
    this.toaddresses = [];
    this.ccaddresses = [];
    this.bccaddresses = [];
    this.subject = "";
    this.message = "";
    this.templateOption = new SelectOption();
    this.maintenancejob = maintenancejob;
    this.prepareEmailAttachmentList();
    let tiptapeditor: any = this.$refs.tiptapeditor as any;
    tiptapeditor.init(maintenancejob);
  }

  get fromaddress() {
    return this.email.fromaddress;
  }
  set fromaddress(val: string) {
    this.email.fromaddress = val;
  }

  get toaddresses() {
    return this.email.toaddresses;
  }
  set toaddresses(val: string[]) {
    this.email.toaddresses = val;
  }

  get ccaddresses() {
    return this.email.ccaddresses;
  }
  set ccaddresses(val: string[]) {
    this.email.ccaddresses = val;
  }

  get bccaddresses() {
    return this.email.bccaddresses;
  }
  set bccaddresses(val: string[]) {
    this.email.bccaddresses = val;
  }

  get subject() {
    return this.email.subject;
  }
  set subject(val: string) {
    this.email.subject = val;
  }

  get message() {
    return this.email.message;
  }
  set message(val: string) {
    this.email.message = val;
  }

  public setTo(val: any[]) {
    this.toaddresses = [...val];
  }

  public setCC(val: any[]) {
    this.ccaddresses = [...val];
  }



  public setBCC(val: any[]) {
    this.bccaddresses = [...val];
  }
  public selectedattachment(attachment: EmailAttachment) {
    let index = this.email.attachments.findIndex(
      (a: EmailAttachment) => a.path === attachment.path
    );
    return index >= 0;
  }
  public toggleselection(attachment: EmailAttachment) {
    let index = this.email.attachments.findIndex(
      (a: EmailAttachment) => a.path === attachment.path
    );
    if (index < 0) this.email.attachments.push(attachment);
    if (index >= 0) this.email.attachments.splice(index, 1);
  }

  public updateMessage(data: string) {
    this.email.message = data;
  }

  public canSend() {
    if (this.toinvalid || this.ccinvalid || this.bccinvalid) return false;
    if (this.toaddresses.length === 0) return false;
    if (this.message.trim().length === 0) return false;
    return true;
  }

  public send() {
    this.sendEmail(this.email)
      .then(() => this.hide())
      .then(() => Vue.toasted.success("Email sent"))
      .catch(err => this.$onecentral.displayError("Error while sending email"));
  }

  hide() {
    const modal = (this.$parent.$refs.quotationEmailModal as any).$el;
    ($(modal) as any).modal("hide");
    this.maintenancejob = new Maintenancejob();
  }

  public prepareEmailAttachmentList() {
    this.attachments = [];
    if(this.maintenancejob?.attachments) {
      if(this.maintenancejob?.attachments?.invoice) {
        this.attachments.push(this.prepareEmailAttachment(this.maintenancejob?.attachments?.invoice));
      }
      if(this.maintenancejob?.attachments?.proforma) {
        this.attachments.push(this.prepareEmailAttachment(this.maintenancejob?.attachments?.proforma));
      }
    }
    return this.attachments;
  }

  public prepareEmailAttachment(val: string): EmailAttachment {
    const filename: string  = this.getAttachmentDisplayname(val);
    let attachement: EmailAttachment = new EmailAttachment({
      filename: filename,
      path: this.$onecentral.prependDownloadsURL(val),
    });
    return attachement;
  }

  public getAttachmentDisplayname(val: string) : string {
    let name: string = "";
    let lastindex = val.lastIndexOf("/");
    if(lastindex >= 0) name = val.substring(lastindex + 1);
    return name;
  }

  get getattachmentlink() {
    return "";
  }

}
